module.exports = __webpack_public_path__ + "img/logo2.55ba6a2c.png";